export const createObjectURLFromBuffer = (
  buffer: Uint8Array<ArrayBuffer> | ArrayBuffer,
  mimeType: string
): string => {
  if (!buffer) {
    throw new Error("Image buffer cannot be null or undefined.")
  }
  if (!mimeType || !mimeType.startsWith("image/")) {
    throw new Error(
      'Invalid MIME type provided. Must be an image MIME type (e.g., "image/png").'
    )
  }

  const data = buffer instanceof ArrayBuffer ? new Uint8Array(buffer) : buffer

  const blob = new Blob([data], { type: mimeType })

  return URL.createObjectURL(blob)
}
